import { RefreshControl as RefreshControlWeb } from 'react-native-web-refresh-control';

export default RefreshControlWeb;
